import { detect } from 'detect-browser';

import React, { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import BrowserErrorModal from 'src/front/components/BrowserErrorModal';
import { UNSUPPORTED_BROWSER } from 'src/front/constant';

import SessionProvider from 'src/front/contexts/SessionContext';
import Application from 'src/front/pages/Application';
import MoneyTransferHistoryIntrabank from 'src/front/pages/applications/call-center/money-transfer-history-intrabank/MoneyTransferHistoryIntrabank';
import MoneyTransferHistory from 'src/front/pages/applications/call-center/money-transfer-history/MoneyTransferHistory';
import CardEntry from 'src/front/pages/applications/card-entry/CardEntry';
import CardObservation from 'src/front/pages/applications/card-observation/CardObservation';
import CardReissue from 'src/front/pages/applications/card-reissue/CardReissue';
import ClientInfo from 'src/front/pages/applications/client-info/ClientInfo';
import ContactInfo from 'src/front/pages/applications/contact-info/ContactInfo';
import AllAccountObservation from 'src/front/pages/applications/customer-all-account-observation/AllAccountObservation';
import ExecutedOperation from 'src/front/pages/applications/executed-operations/ExecutedOperations';
import LoanApplication from 'src/front/pages/applications/loan-application/LoanApplication';
import NewObserve from 'src/front/pages/applications/new-observe/NewObserve';
import NewSettlement from 'src/front/pages/applications/new-settlement/NewSettlement';
import OnlinePosActivation from 'src/front/pages/applications/online-pos-activation/OnlinePosActivation';
import PaymentPlanSimulation from 'src/front/pages/applications/payment-plan-simulation/PaymentPlanSimulation';
import PlasticCardRegistration from 'src/front/pages/applications/plastic-card-registration/PlasticCardRegistration';
import ProblemTrackingSystem from 'src/front/pages/applications/problem-tracking-system/ProblemTrackingSystem';
import Result from 'src/front/pages/applications/Result';
import UploadDocument from 'src/front/pages/applications/upload-document/UploadDocument';
import ViewCredits from 'src/front/pages/applications/view-credits/ViewCredits';
import CallCenter from 'src/front/pages/CallCenter';
import ChangePassword from 'src/front/pages/change-password/ChangePassword';
import Dashboard from 'src/front/pages/Dashboard';

import Login from 'src/front/pages/Login';

import {
  ALL_ACCOUNT_OBSERVATION,
  APPLICATION,
  CALLCENTER,
  CARD_ENTRY,
  CARD_OBSERVATION,
  CARD_REISSUE,
  CC_MONEY_TRANSFER_HISTORY,
  CHANGE_PASSWORD,
  CLIENT_INFO,
  CONTACT_INFO,
  DASHBOARD,
  EXECUTED_OPERATIONS,
  IE_ERROR,
  INTRABANK_MONEY_TRANSFER_HISTORY,
  LOAN_APPLICATION,
  LOGIN,
  NEW_OBSERVE,
  NEW_SETTLEMENT,
  ONLINE_POS,
  PAYMENT_PLAN_SIMULATION,
  PLASTIC_CARD_REGISTRATION,
  PROBLEM_TRACKING_SYSTEM,
  RESULT,
  UPLOAD_DOCUMENT,
  VIEW_CREDITS,
} from './paths';
import PrivateRoute from './PrivateRoute';

const browser = detect();

const Router: FC = () => (
  <SessionProvider>
    <Switch>
      <Route path={LOGIN} exact>
        {browser?.name === UNSUPPORTED_BROWSER ? <Redirect to={IE_ERROR} /> : <Login />}
      </Route>
      <Route component={BrowserErrorModal} path={IE_ERROR} exact />
      <PrivateRoute component={Dashboard} path={DASHBOARD} exact />
      <PrivateRoute component={Application} path={APPLICATION} exact />
      <PrivateRoute component={CallCenter} path={CALLCENTER} exact />
      <PrivateRoute component={CardEntry} path={CARD_ENTRY} exact />
      <PrivateRoute component={Result} path={RESULT} exact />
      <PrivateRoute component={OnlinePosActivation} path={ONLINE_POS} exact />
      <PrivateRoute component={CardObservation} path={CARD_OBSERVATION} exact />
      <PrivateRoute component={ClientInfo} path={CLIENT_INFO} exact />
      <PrivateRoute component={UploadDocument} path={UPLOAD_DOCUMENT} exact />
      <PrivateRoute component={CardReissue} path={CARD_REISSUE} exact />
      <PrivateRoute component={ExecutedOperation} path={EXECUTED_OPERATIONS} exact />
      <PrivateRoute component={ChangePassword} path={CHANGE_PASSWORD} exact />
      <PrivateRoute component={ContactInfo} path={CONTACT_INFO} exact />
      <PrivateRoute component={NewSettlement} path={NEW_SETTLEMENT} exact />
      <PrivateRoute component={NewObserve} path={NEW_OBSERVE} exact />
      <PrivateRoute component={LoanApplication} path={LOAN_APPLICATION} exact />
      <PrivateRoute component={ViewCredits} path={VIEW_CREDITS} exact />
      <PrivateRoute component={MoneyTransferHistory} path={CC_MONEY_TRANSFER_HISTORY} exact />
      <PrivateRoute
        component={MoneyTransferHistoryIntrabank}
        path={INTRABANK_MONEY_TRANSFER_HISTORY}
        exact
      />
      <PrivateRoute component={PlasticCardRegistration} path={PLASTIC_CARD_REGISTRATION} exact />
      <PrivateRoute component={ProblemTrackingSystem} path={PROBLEM_TRACKING_SYSTEM} exact />
      <PrivateRoute component={PaymentPlanSimulation} path={PAYMENT_PLAN_SIMULATION} exact />
      <PrivateRoute component={AllAccountObservation} path={ALL_ACCOUNT_OBSERVATION} exact />
    </Switch>
  </SessionProvider>
);

export default Router;
